"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.prompt-assist.disabled': '提示助手功能在您当前的计划中不可用。',
};
